import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Container, Box, useScrollTrigger } from '@mui/material';

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('home');
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'plans', 'coverage', 'contact', 'faq'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) {
        setActiveSection(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{
        backgroundColor: trigger ? 'rgba(0, 0, 0, 0.9)' : 'transparent',
        boxShadow: trigger ? 1 : 'none',
        transition: 'background-color 0.3s ease-in-out',
      }}
    >
      <Container>
        <Toolbar>
          <Typography 
            variant="h6" 
            onClick={() => scrollToSection('home')}
            sx={{ 
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            DEVOLVED TELCO LIMITED
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', gap: 1 }}>
            {[
              { id: 'plans', label: 'Plans' },
              { id: 'coverage', label: 'Coverage' },
              { id: 'contact', label: 'Contact' },
              { id: 'faq', label: 'FAQ' },
            ].map(({ id, label }) => (
              <Button 
                key={id}
                color="inherit" 
                onClick={() => scrollToSection(id)}
                sx={{
                  fontWeight: activeSection === id ? 700 : 400,
                  borderBottom: activeSection === id ? 2 : 0,
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  }
                }}
              >
                {label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
